import {
  Autocomplete,
  Box,
  BoxStatus,
  GraphicFilters,
  Label,
  Stack,
  StackRow,
  ListActivityCard,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Heading,
  Button,
  Flexbox,
  TableBasic,
} from "codekit";
import {
  useLazyGetGroupsByFiltersQuery,
  useLazyGetDataGraphicGroupsByTurnsQuery,
  useLazyGetUserdByTurnsQuery,
} from "../../../../libs/redux/slices/Graficsx/Userturx/userturxApiSlice";
import { useCallback, useEffect, useState, useMemo } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";

const colorChart = ["secondary", "success", "warning", "error", "accent", "primary", "info"];

const Userturx = ({ graphName }) => {
  const [getGroups] = useLazyGetGroupsByFiltersQuery();
  const [getDataGraphic, { isFetching: isFetchingGraphic }] = useLazyGetDataGraphicGroupsByTurnsQuery();
  const [getUsersByCco] = useLazyGetUserdByTurnsQuery();

  const [resultsClient, setResultsClient] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [userData, setUserData] = useState([]);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [dataGraphic, setDataGraphic] = useState([]);
  const [colorsChart, setColorsChart] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedItem, setSelectedItem] = useState(null);

  const { control, reset } = useForm({
    mode: "onBlur",
    defaultValues: {
      CLIIDXXX: "",
      USRIDXXX: ""
    },
  });

  const formValues = useWatch({ control });

  const formatTime12h = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(':');
    let h = parseInt(hours);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return `${h}:${minutes} ${ampm}`;
  };

  const handleFetchData = useCallback(async (dateObj, currentValues) => {
    console.log("CAMBIE EL FILTRO DE BUISQUEDA")
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const params = {
      filters: {
        "filters[GRUTURID]": currentValues.CLIIDXXX ? currentValues.CLIIDXXX.split(" - ")[0] : "",
        "filters[USRIDXXX]": "",
        "filters[TURIDFEC]": formattedDate,
      }
    };

    try {
      const response = await getDataGraphic(params).unwrap();
      const { data } = response;

      const shiftColorMap = {};
      let nextColorIndex = 0;

      const formattedData = data.map((item) => {
        const horaInicio = formatTime12h(item.TURGRUIN);
        const horaFin = formatTime12h(item.TURGRUFI);
        return {
          id: item.GRUTURID,
          title: "",
          subtitle: `${item.GRUTURID} - ${item.GRUTURDE}  ${horaInicio} - ${horaFin}`,
          CCOIDXXX: item.GRUTURID,
          originalData: item
        };
      });

      const computedColors = data.map((item) => {
        const shiftId = item.TURIDXXX || 'default';
        if (!shiftColorMap[shiftId]) {
          shiftColorMap[shiftId] = getColorByIndex(nextColorIndex++);
        }
        return shiftColorMap[shiftId];
      });

      setDataGraphic(formattedData);
      setColorsChart(computedColors);
    } catch (e) {
      console.error("Error al obtener datos del gráfico:", e);
    }
  }, [getDataGraphic]);

  useEffect(() => {
    handleFetchData(selectedDate, formValues);
  }, [selectedDate, formValues.CLIIDXXX, handleFetchData]);

  const searchClient = async (CLIIDXXX, cb) => {
    return await getGroups(CLIIDXXX)
      .unwrap()
      .then((response) => setResultsClient(response.data))
      .catch(() => { })
      .finally(() => cb());
  };

  const getColorByIndex = (index) => {
    const colorIndex = index % colorChart.length;
    const baseColor = colorChart[colorIndex];
    return {
      bgColor: `${baseColor}-100`,
      iconColor: `${baseColor}-500`,
      textColor: `${baseColor}-600`,
    };
  };

  const handleOpenUserDetail = async (item) => {
    setSelectedItem(item);
    setOpenModal(true);
    setIsModalLoading(true);
    const filters = { GRUTURID: item.CCOIDXXX };
    await getUsersByCco({ filters })
      .unwrap()
      .then((response) => setUserData(response.data || []))
      .catch(() => setUserData([]))
      .finally(() => setIsModalLoading(false));
  };

  const handleDateSelection = async (date) => {
    if (date instanceof Date) {
      setSelectedDate(date);
    }
  };

  // Definición de columnas para la tabla del modal
  const tableColumns = [
    { id: "USRUNOMX", title: "Nombre de Usuario", sorted: false },
    { id: "USRUCARX", title: "Cargo", sorted: false },
  ];


  const formattedUserData = useMemo(() => {
    return userData.map((user) => ({
      USRUNOMX: user.USRNOMXX,
      USRUCARX: user.CARDESXX,
    }));
  }, [userData]);

  return (
    <Box spacing={4}>
      <GraphicFilters
        containerName={graphName}
        graphicKeyName="Userturx"
        clearFilters={() => {
          reset();
          setSelectedDate(new Date());
        }}
      >
        <Box>
          <Box mb={8} borderBottom={1} spacing={2}>
            <Stack gap={3} columnsVariant="form-1">
              <StackRow>
                <Label>Grupo</Label>
                <Controller
                  control={control}
                  name="CLIIDXXX"
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      selected={value}
                      searchResults={resultsClient}
                      minLengthToSearch={2}
                      onChangeSearch={(val, cb) => searchClient(val, cb)}
                      onItemClick={(ctx) => onChange(`${ctx.item.label}`)}
                      onResetSelected={() => onChange("")}
                    />
                  )}
                />
              </StackRow>
            </Stack>
          </Box>

          <Box>
            {isFetchingGraphic ? (
              <BoxStatus variant="loading" text="Buscando información..." />
            ) : (
              <ListActivityCard
                titleSection="Turnos VS Grupos"
                data={dataGraphic}
                value={selectedDate}
                listColors={colorsChart}
                onAction={(item) => handleOpenUserDetail(item)}
                onDateChange={(date) => handleDateSelection(date)}
                onClickCard={(item) => {
                  console.log(item);
                  if (item instanceof Date) {
                    setSelectedDate(item);
                  }
                }}
              />
            )}
          </Box>
        </Box>
      </GraphicFilters>
      <Modal size="xl" isOpen={openModal}>
        <ModalHeader>
          <Flexbox justifyContent="between" alignItems="center">
            <Heading variant="heading-5" color="accent-600">
              {selectedItem ? selectedItem.subtitle : "Detalle de Usuarios y Cargos"}
            </Heading>
            <Button
              variant="secondary"
              icon="close"
              onlyIcon
              size="m"
              onClick={() => setOpenModal(false)}
            />
          </Flexbox>
        </ModalHeader>
        <ModalBody size="sm">
          {isModalLoading ? (
            <BoxStatus variant="loading" text="Consultando usuarios..." />
          ) : (
            <Box mt={4}>
              <TableBasic
                columns={tableColumns}
                data={formattedUserData}
                dataLength={formattedUserData.length}
                hasMore={false}
                textNoResults="No se encontró información de usuarios."
              />
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Flexbox justifyContent="between" alignItems="center" gap={4}>
            <Button
              type="button"
              variant="secondary"
              size="2l"
              minWidth={200}
              onClick={() => setOpenModal(false)}
            >
              Cancelar
            </Button>
          </Flexbox>
        </ModalFooter>
      </Modal>
    </Box>
  );
};

export default Userturx;
